import React from 'react';
import PropTypes from 'prop-types';
import { Box, Skeleton } from '@mui/material';

// MUI default skeleton grey is harsh on the warm sidebar; softer base, wave animation unchanged
const navSkeletonBaseSx = { bgcolor: 'rgba(49, 49, 49, 0.04)' };

// List-only nav skeleton blocks (parent supplies `List` + `columnSectionBorder` class for dividers).
const NavigationDrawerSkeleton = ({ dividerClassName }) => {
  const skeletonRow = (key, labelWidth = '66%') => (
    <Box
      key={key}
      sx={{
        minHeight: '40px',
        padding: '6px 12px',
        marginBottom: '6px',
        borderRadius: '8px',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px', minHeight: '24px' }}>
        <Skeleton
          variant='circular'
          width={16}
          height={16}
          animation='wave'
          sx={{ ...navSkeletonBaseSx, flexShrink: 0 }}
        />
        <Skeleton
          variant='rounded'
          height={16}
          width={labelWidth}
          animation='wave'
          sx={{ ...navSkeletonBaseSx, borderRadius: '6px' }}
        />
      </Box>
    </Box>
  );

  const skeletonHeader = (key, marginTop = 10, marginBottom = 24) => (
    <Skeleton
      key={key}
      variant='rounded'
      height={12}
      width={112}
      animation='wave'
      sx={{
        ...navSkeletonBaseSx,
        borderRadius: '4px',
        marginTop: `${marginTop}px`,
        marginBottom: `${marginBottom}px`,
        marginLeft: '8px',
      }}
    />
  );

  const skDivider = (key) => (
    <Box key={key} className={dividerClassName} sx={{ marginTop: '20px', marginBottom: '20px' }} />
  );

  return (
    <>
      {skeletonHeader('sk-m-h', 24)}
      <Box key='sk-m-gap' sx={{ height: '12px' }} />
      {skeletonRow('sk-m-1', '62%')}
      {skeletonRow('sk-m-2', '46%')}
      <Box key='sk-m-end-gap' sx={{ height: '8px' }} />
      {skDivider('sk-div-1')}
      {skeletonHeader('sk-d-h')}
      <Box key='sk-d-gap' sx={{ height: '12px' }} />
      <Skeleton
        key='sk-create'
        variant='rounded'
        height={40}
        width={160}
        animation='wave'
        sx={{
          ...navSkeletonBaseSx,
          borderRadius: '100px',
          marginTop: '6px',
          marginBottom: '6px',
          marginLeft: '12px',
        }}
      />
      {skeletonRow('sk-d-1', '58%')}
      {skeletonRow('sk-d-2', '70%')}
      <Box key='sk-d-end-gap' sx={{ height: '8px' }} />
      {skDivider('sk-div-2')}
      {skeletonHeader('sk-s-h')}
      <Box key='sk-s-gap' sx={{ height: '12px' }} />
      {skeletonRow('sk-s-1', '76%')}
      {skeletonRow('sk-s-2', '38%')}
    </>
  );
};

NavigationDrawerSkeleton.propTypes = {
  dividerClassName: PropTypes.string.isRequired,
};

export default NavigationDrawerSkeleton;
